import styled from 'styled-components';

export const BreadCrumbContainer = styled.div`
  svg {
    margin-right: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  }

  a {
    font-size: ${({ theme }) => theme.yoga.fontSizes.medium}px;
    font-weight: ${({ theme }) => theme.yoga.fontWeights.regular};
    line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
    letter-spacing: ${({ theme }) => theme.yoga.spacing.zero}px;
    color: ${({ theme }) => theme.yoga.colors.deep};
  }
`;

export const CrumbContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xxsmall}px;

  + hr {
    margin: 0px;
  }
`;
